import { TimeSeriesPoint } from "../models/advistory";

export const normalizePercent = (value: number) =>
  value <= 1 ? value * 100 : value;

export const formatDateTime = (iso: string) => {
  const date = new Date(iso);

  return date.toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    hour: "numeric",
    hour12: true,
  });
};

export const normalizeSeries = (series: TimeSeriesPoint[]) =>
  series.map((p) => ({
    time: formatDateTime(p.time),
    pm: normalizePercent(p.pm),
    dm: normalizePercent(p.dm),
  }));
